import React, { useEffect } from 'react';
import { Box, Typography, Breadcrumbs } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Link, useParams } from 'react-router-dom';
import Header from '../components/Header';
import useRTL from 'src/hooks/useRTL';
import { createMarkup } from '../../shared/logic/Utils';
import { useCompanyData } from '../../shared/contexts/DataContext';
import { contactImage } from '../../shared/logic/imagesFns';

const useStyles = makeStyles((theme) => ({
    descSpan:{
        paddingTop:'25px',
        fontSize:'16px',
        width:'100%',
        textOverflow:'ellipsis',
        '& li':{
        listStyle:'inherit'
        },

        [theme.breakpoints.down('sm')]:{
        paddingTop:'16px', 
        }
    },

    breadWhite:{
        color:'#fff',
        fontSize:'1.3rem'
    },

    headerWid100:{
        width:'100%',
        maxWidth:'100%'
    }
}));

const Privacy = () => {
  const { data } = useCompanyData();
  const [, , fontFamily] = useRTL('',"Playfair Display, serif");
  const classes = useStyles();
  const { t, privacyLink } = data || {};

  useEffect(()=> {
    window.scrollTo(0, 0);
  },[])

  return (
    <div>
      <SimpleHeader 
        {...{
          data,
          title: t && t('booking.privacy')
        }}
      />

    <Box
        py={5}
        width="90%"
        m="auto"
        display="flex"
        justifyContent="space-between"
        flexWrap="wrap"
        mt="100px"
    >
        <Typography variant="body1" className={classes.descSpan} style={{fontFamily:'inherit'}} dangerouslySetInnerHTML={createMarkup(privacyLink)}></Typography>
    </Box>
      
    </div>
  );
};

function SimpleHeader({data, title}){
  const classes = useStyles();
  const { t, companyDomain, displayBanner=true } = data || {};
  const { id } = useParams();

  return(
    <Header image={contactImage(data)} 
      data={data}
      customCls={classes.headerWid100}
      height="500px"
      title={title}
      transparencyColor={'#15476db2'}
      bannerStyle={data.bannerStyle ? data.bannerStyle : 'boxed'}
      displayBanner={displayBanner}
      titleColor="#ffffff"
      >
        <Breadcrumbs aria-label="breadcrumb" style={{fontFamily:'inherit'}} classes={{separator:classes.breadWhite,li:classes.breadWhite}}>
          <Link to={companyDomain ? '/' : `/${id}`}>
            {t && t('companyPage.home')}
          </Link>
          <Typography style={{color:'#17c799',fontSize:'1.2rem',textTransform:'capitalize'}}>{title}</Typography>
        </Breadcrumbs>
    </Header>
  )
}

export default Privacy;